import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormEsasFilledByEnum } from '../../../../../../../../../types/src/services/enum/form-esas-filled-by.enum';
import { FormBaseFormStore } from '../form-base-form/form-base-form.store';
import { FormBaseFormComponent, FormItem } from '../form-base-form/form-base-form.component';
import { FormSetEnum } from '../../../../../../../../../types/src/services/enum/form-set.enum';
import { esasKeys } from '@libs/shared/form-helpers/forms/forms-json-keys';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import {
    TextAreaInputComponent,
} from '../../../../../../components/kit/input/text-area-input/text-area-input.component';
import { FormatPersonPipe } from '../../../../../shared/pipes/format-person.pipe';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-form-esas-form',
    templateUrl: './form-esas-form.component.html',
    styleUrls: ['../form-base-form/form-base-form.scss'],
    providers: [FormBaseFormStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslatePipe,
        SelectInputComponent,
        TextAreaInputComponent,
        FormatPersonPipe,
        DateInputComponent,
        ActionButtonsComponent,
    ],
})
export class FormEsasFormComponent extends FormBaseFormComponent implements OnInit {

    public readonly translate = inject(TranslateService);

    filledByOptions = [
        { value: FormEsasFilledByEnum.PATIENT, name: FormEsasFilledByEnum.PATIENT },
        { value: FormEsasFilledByEnum.CAREGIVER, name: FormEsasFilledByEnum.CAREGIVER },
        { value: FormEsasFilledByEnum.MEDIC, name: FormEsasFilledByEnum.MEDIC },
    ];

    constructor() {
        super();

        this.formUniqueIdentifier = FormSetEnum.ESAS;
        this.keys = esasKeys;

        const formConfig: FormItem[] = this.keys.map((key) => (
            { name: key, defaultValue: -1, required: false }
        ));
        formConfig.push({ name: 'filledBy', defaultValue: FormEsasFilledByEnum.MEDIC, required: true });
        formConfig.push({
            name: 'time',
            defaultValue: new Date(),
            required: true,
            patchValueCallback: (time) => this.copy ? new Date() : new Date(time),
        });
        formConfig.push({ name: 'note', defaultValue: null, required: false });
        this.generateForm(formConfig);

        for (let i = 0; i <= 10; i++) this.options.push({ value: i, name: i.toString() });
        this.options.push({ value: -1, name: this.translate.instant('form.esas.unknownValue') });
    }

    override ngOnInit() {
        super.ngOnInit();
        if (!this.folderFormData) {
            this.generateFinalEvaluation({});
        }
    }
}
